import { useEffect, useState } from 'react';
import type { Entry } from './game';

export const REVEAL_MS = 8000;
// Reduced motion: the visitor sharpens in steps instead, and each step costs points.
export const STEP_SCORE = [8, 6, 4, 2, 1];
const STEP_BLUR = [28, 18, 10, 4, 0];

// A cover that starts blurred and sharpens over REVEAL_MS.
// Keyed per round by the caller, so the sharpen step resets with each cover.
export function BlurCover({ entry, answered, stepped, onStep }: {
  entry: Entry; answered: boolean; stepped: boolean; onStep: (step: number) => void;
}) {
  const [step, setStep] = useState(0);
  useEffect(() => onStep(step), [step, onStep]);
  return (
    <>
      <div className="reveal-frame is-blur" style={{ aspectRatio: entry.ratio }}>
        <img src={entry.image} alt="A blurred cover to guess"
          className={`reveal-img${answered ? ' is-revealed' : stepped ? '' : ' is-animated'}`}
          style={stepped && !answered ? { filter: `blur(${STEP_BLUR[step]}px)` } : undefined} />
      </div>
      {stepped && !answered && step < STEP_SCORE.length - 1 && (
        <button type="button" className="arc-btn arc-btn-sm" onClick={() => setStep(step + 1)}>
          Sharpen (−{STEP_SCORE[step] - STEP_SCORE[step + 1]} pts)
        </button>
      )}
    </>
  );
}
